import React from "react";
import { Container, Stack } from "@mui/material";

import { Header } from "src/widgets/Header";
import { CopyRight } from "src/widgets/CopyRight";
import { WbMainInfo } from "src/widgets/WBMainInfo";
import { WBGifSections } from "src/widgets/WBGifSections";
import { WbPricing } from "src/widgets/WBPricing";
import { WBDemoVideo } from "src/widgets/WBDemoVideo";
// import { BackgroundLinkedParticles } from "src/widgets/BackgroundLinkedParticles";

import { ContactsPage } from "../ContactsPage/ContactsPage";

export const ToolsPage: React.FC = () => {
  return (
    <>
      {/*<BackgroundLinkedParticles />*/}
      <Stack
        width={1}
        minHeight="100vh"
        bgcolor="papper.default"
        direction="column"
        justifyContent="flex-start"
        alignItems="center"
      >
        <Container
          maxWidth="lg"
          sx={{
            width: 1,
            height: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            backgroundColor: "transparent",
            gap: { md: 12, sm: 8, xs: 4 },
            zIndex: 1,
          }}
        >
          <Header />

          <WbMainInfo />

          <WBDemoVideo />

          <WBGifSections />
        </Container>

        <WbPricing />

        <Container
          maxWidth="lg"
          sx={{
            width: 1,
            height: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "center",
            gap: { md: 12, sm: 8, xs: 4 },
          }}
        >
          <ContactsPage />

          <CopyRight />
        </Container>
      </Stack>
    </>
  );
};
